import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Alert } from "components/bootstrap";
import useGranteeTypeLabel from "components/permissions/useGranteeTypeLabel";
const Container = styled(Alert)`
  margin-top: 20px;
  max-height: 240px;
  overflow: auto;
`;
const List = styled.ul`
  list-style: initial;
  padding-left: 20px;

  ul {
    list-style: circle;
  }
`;
const ValidationError = ({ validationResult, availableGrantees }) => {
  const { t } = useTranslation("users");
  const granteeTypeLabel = useGranteeTypeLabel();
  const pastOwners = validationResult.errorContext.selectedGranteeCapabilities.map(
    (grn) => availableGrantees.find((grantee) => grantee.id === grn)
  );
  return /* @__PURE__ */ React.createElement(Container, { bsStyle: "danger" }, /* @__PURE__ */ React.createElement(List, null, /* @__PURE__ */ React.createElement("li", null, t("permissions.validation_error.ownerless"), " ", /* @__PURE__ */ React.createElement("br", null), pastOwners.map((owner, key) => /* @__PURE__ */ React.createElement("span", { key: owner == null ? void 0 : owner.id }, granteeTypeLabel(owner == null ? void 0 : owner.type), " ", /* @__PURE__ */ React.createElement("i", null, owner == null ? void 0 : owner.title), key !== pastOwners.size - 1 && ", ")).toArray())));
};
export default ValidationError;
